import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../package.json";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const fetchTripsLock = createAsyncThunk(
  "TripLock/fetchTripsLock",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/getTripsIsLock/${id}`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const result = await res.data.data;

      return result;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        //Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);

export const fetchTripIsLock = createAsyncThunk(
  "TripLock/fetchTripIsLock",
  async (data, thunkAPI) => {
    const { rejectWithValue,dispatch } = thunkAPI;

    try {
      dispatch(clearTripLockState());
      // Include the branch as a query parameter
      const res = await axios.get(`${BaseUrl}/getTripIsLock/${data.id_trip}`, {
                headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, 
      });
      const result = res.data.data;
      return result;
    } catch (error) {
      // Check if the error status code is 403 Forbidden or another status code
      if (error.response && error.response.status === 403) {
        // Handle the 403 Forbidden error specifically
        sweetalert({
          text: "ليس لديك صلاحية للقيام بهذا",
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      } 
     else if (error.response && error.response.status === 401) {
        //Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      else {
        // Handle other errors with a generic message
        const errorMessage =
          error.response?.data?.message || error.response?.data?.data;
        sweetalert({
          text: errorMessage,
          icon: "error",
          buttons: {
            confirm: {
              text: "إغلاق",
              className: "custom-button-class",
            },
          },
          className: "alert-div",
        });
      }
      return rejectWithValue(error.message);
    }
  }
);




const TripLockSlice = createSlice({
  name: "TripLock",
  initialState: {
    TripLocks: [],
    TripLock: [],
    loading: false,
    loadingGet: false,
    error: null,
  },
  reducers: {
    clearTripLocksState: (state) => {
      state.TripLocks = [];
      state.TripLock = [];
      state.loading = false;
      state.loadingGet = false;
      state.error = null;
    },
    clearTripLockState: (state) => {

      state.TripLock = [];
      state.loadingGet = false;
  
    },
  
  },
  extraReducers: {
    //fetch
    [fetchTripsLock.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchTripsLock.fulfilled]: (state, action) => {
      state.TripLocks = action.payload;
      state.loading = false;
    },
    [fetchTripsLock.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [fetchTripIsLock.pending]: (state, action) => {
      state.loadingGet = true;
      state.error = null;
    },
    [fetchTripIsLock.fulfilled]: (state, action) => {
      state.TripLock = action.payload;
      state.loadingGet = false;
    },
    [fetchTripIsLock.rejected]: (state, action) => {
      state.error = action.payload;
      state.loadingGet = false;
    },
  
  },
});
export const {  clearTripLocksState ,clearTripLockState} = TripLockSlice.actions;
export default TripLockSlice.reducer;
